import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux";
import {Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import { getOnCallPolicies as onGetAllOnCallPolicies } from "../../store/onCallPolicy/actions";
import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from 'formik';
import Multiselect from 'multiselect-react-dropdown';
import {
  postUpdateService, getSpecificServices, getBluejayMasterCommunicationChannels,
  postBluejayCommunicationChannelByServiceId,
  getServices as onGetServices,
} from "../../store/service/actions";
import { team_values as TEAM_VALUES } from "../../constants/data_types";
import { notification_channel_names as NOTIFICATION_CHANNEL } from "constants/data_types";

const OnEditModal = props => {
  const dispatch = useDispatch()
  const { isOpen, toggle, serviceId } = props;
  const [service, setService] = useState(null);
  const [selectedOnCallPolicy, setSelectedOnCallPolicy] = useState(null);
  const [selectedBluejayTeam, setSelectedBluejayTeam] = useState(null);
  const [selectedMsTeam, setSelectedMsTeam] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const { services } = useSelector(state => ({
    services: state.Service.services
  }));

  const domain = window.location.hostname;

  const policies = useSelector((state) => state.onCallPolicy.policies || []);

  const { bluejayTeams } = useSelector(state => ({
    bluejayTeams: state.Organization.bluejay_teams || []
  }))

  const { msTeamsChannels } = useSelector(state => ({
    msTeamsChannels: state.MSTeams.msTeamsChannels
  }))

  const availableMsTeams = msTeamsChannels?.map((msTeamsChannels) => ({
    id: msTeamsChannels?.id,
    name: msTeamsChannels?.name,
  }));

  const availableMsTeamsOptions = availableMsTeams?.length > 0
    ? availableMsTeams.map((msTeam) => ({
      label: msTeam.name,
      value: msTeam.id,
    })).concat({ label: 'Unmapped', value: TEAM_VALUES.UNMAPPED })
    : [{ label: 'Unmapped', value: TEAM_VALUES.UNMAPPED }];

  const availableTeams = bluejayTeams?.map((bluejayTeams) => ({
    id: bluejayTeams?.id,
    name: bluejayTeams?.name,
  }));

  const availalbeTeamsOptions = availableTeams?.length > 0
    ? availableTeams.map((team) => ({
      label: team.name,
      value: team.id,
    })).concat({ label: 'Unmapped', value: TEAM_VALUES.UNMAPPED })
    : [{ label: 'Unmapped', value: TEAM_VALUES.UNMAPPED }];

  const availablePolicies = policies?.map((policies) => ({
    id: policies?.id,
    name: policies?.name,
  }));
  const validateEmails = (emailString) => {
    const emailArray = emailString.split(',').map(email => email.trim());
    let isValid = true;
    let invalidEmails = [];
    emailArray.forEach(email => {
      if (!Yup.string().email().isValidSync(email)) {
        isValid = false;
        invalidEmails.push(email);
      }
    });

    return { isValid, invalidEmails };
  };

  const availablePoliciesOptions = availablePolicies?.length > 0
    ? availablePolicies.map((policy) => ({
      label: policy.name,
      value: policy.id,
    }))
    : [];
  useEffect(() => {
    dispatch(onGetAllOnCallPolicies());
  }, [onGetAllOnCallPolicies]);

  useEffect(() => {
    dispatch(onGetServices());
  }, [onGetServices]);

  // useEffect(() => {
  //   dispatch(getBluejayMasterCommunicationChannels());
  // }, [getBluejayMasterCommunicationChannels]);
  //
  //
  // const {communication_channels}=useSelector(state => ({
  //   communication_channels: state.Service.communication_channels,
  // }))
  const communicationChannelsById = useSelector(state => state.Service.communication_channels_by_id || []);

  useEffect(() => {
    if (communicationChannelsById.length > 0) {
      const enabledIds = communicationChannelsById
        .filter(channel => channel.enabled)
        .map(channel => channel.id);

      setSelectedIds(enabledIds);
    }
  }, [communicationChannelsById]);

  const handleCheckboxChange = (id, checked) => {
    const updatedIds = checked
      ? [...selectedIds, id]
      : selectedIds.filter(selectedId => selectedId !== id);

    setSelectedIds(updatedIds);
  };

  useEffect(() => {
    const selected_service = services.find(service => service.id === serviceId);
    setService(selected_service);
  }, [serviceId, services])

  useEffect(() => {
    if (service && service?.bluejay_oncall_policy) {
      const selectedOption = availablePoliciesOptions.find(
        (option) => option.label === service?.bluejay_oncall_policy?.name
      );
      setSelectedOnCallPolicy(selectedOption);
    }
  }, [service]);

  useEffect(() => {
    if (service && service?.bluejay_team) {
      const selectedOption = availalbeTeamsOptions.find(
        (option) => option.label === service?.bluejay_team?.name
      );
      setSelectedBluejayTeam(selectedOption);
    }
  }, [service])

  useEffect(() => {
    if (service && service?.ms_team_channel) {
      const selectedOption = availableMsTeamsOptions.find(
        (option) => option.label === service?.ms_team_channel?.name
      );
      setSelectedMsTeam(selectedOption);
    }
  }, [service])

  const validationFunction = () => {
    let errors = {};
    if (!validation.values.new_email) {
      errors.new_email = "Email is required";
    } else {
      const { isValid, invalidEmails } = validateEmails(validation.values.new_email);
      if (!isValid) {
        errors.new_email = `Invalid email(s): ${invalidEmails.join(', ')}`;
      }
    }
    if (!validation.values.new_name) {
      errors.new_name = "Name is required";
    }

    return errors;
  }

  const validation = useFormik({
    enableReinitialize: true,
    validate: validationFunction,
    initialValues: {
      application_service_id: service?.id,
      new_name: service?.name,
      new_email: service?.email_id,
      new_slack_channel_name: service?.slack_channel_name,
      new_ms_team_channel_name: service?.ms_team_channel_name,
      on_call_policy: selectedOnCallPolicy?.label,
      bluejay_team: selectedBluejayTeam?.label,
      ms_team: selectedMsTeam?.label
    },
    onSubmit: (values) => {
      const selectedPolicy = availablePolicies.find(
        (policy) => policy.name === values.on_call_policy
      );

      const selectedTeam = availableTeams.find(
        (team) => team.name === values.bluejay_team
      );

      const selectedMsTeam = availableMsTeams.find(
        (msTeam) => msTeam.name === values.ms_team
      );

      values.on_call_policy = selectedPolicy ? selectedPolicy.id : null;
      values.bluejay_team_id = selectedTeam ? selectedTeam.id : null;
      values.ms_team_id = selectedMsTeam ? selectedMsTeam.id : null;

      if (values.bluejay_team === "Unmapped") {
        values.bluejay_team_id = TEAM_VALUES.UNMAPPED
      }

      if (values.ms_team === "Unmapped") {
        values.ms_team_id = TEAM_VALUES.UNMAPPED
      }

      const payload = {
        application_service_id: serviceId,
        selected_notification_channels: selectedIds
      };  

      dispatch(postUpdateService(values));
      dispatch(getSpecificServices(values.application_service_id));
      dispatch(postBluejayCommunicationChannelByServiceId(payload));
      toggle();
    }
  })

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#473753',
      position: "absolute",
      zIndex: 200,
      // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100, 
    }),
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          Edit Service
        </ModalHeader>
        <ModalBody>
          <Form
            className='form-horizontal'
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
            }}
          >
            <Row>
              <Col>
                <div className="mb-3">
                  <Label htmlFor="new_name">Edit Name</Label>
                  <div className="mb-3">
                    <Input
                      id="new_name"
                      name="new_name"
                      type="text"
                      required
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.new_name || ""}
                      invalid={
                        validation.touched.new_name && validation.errors.new_name ? true : false
                      }
                    />
                    {validation.touched.new_name && validation.errors.new_name && (
                      <FormFeedback type="invalid">{validation.errors.new_name}</FormFeedback>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <Label htmlFor="new_email">Edit Email</Label>
                  <div className="mb-3">
                    <Input
                      id="new_email"
                      name="new_email"
                      type="text"
                      required
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.new_email || ""}
                      invalid={
                        validation.touched.new_email && validation.errors.new_email ? true : false
                      }
                    />
                    {validation.touched.new_email && validation.errors.new_email && (
                      <FormFeedback type="invalid">{validation.errors.new_email}</FormFeedback>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <Label
                    htmlFor="new_slack_channel_name"> {service?.slack_channel_name ? "Edit Slack Channel" : "Add New Slack Channel"}</Label>
                  <div className="input-org">
                    <Input
                      id="new_slack_channel_name"
                      name="new_slack_channel_name"
                      type="text"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.new_slack_channel_name || ""}
                    />
                  </div>
                </div>
                {(domain === 'msteamtestaccount.temperstack.com' || domain === '10xengg.myapp.com' || domain.endsWith('temperstack.dev')) ? (
                  <>
                    <div className="mb-3">
                      <Label htmlFor="name">Select MS Team</Label>
                      <Select
                        id="ms_team"
                        name="ms_team"
                        onBlur={validation.handleBlur}
                        value={availableMsTeamsOptions.find(
                          (option) => option.label === validation.values.ms_team
                        )}
                        placeholder="Add MS Team"
                        onChange={(selectedOption) => {
                          validation.setFieldValue("ms_team", selectedOption.label);
                        }}
                        options={availableMsTeamsOptions}
                        className="select2-selection col-form-label"
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                      />
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="new_ms_team_channel_name"> {service?.ms_team_channel_name ? "Edit MS Team Channel" : "Add New MS Team Channel"}</Label>
                      <div className="input-org">
                        <Input
                          id="new_ms_team_channel_name"
                          name="new_ms_team_channel_name"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.new_ms_team_channel_name || ""}
                        />
                      </div>
                    </div>
                  </>) : null}
                <div className="mb-3">
                  <Label htmlFor="name">Select On-Call policy</Label>
                  <Select
                    id="on_call_policy"
                    name="on_call_policy"
                    onBlur={validation.handleBlur}
                    value={availablePoliciesOptions.find(
                      (option) => option.label === validation.values.on_call_policy
                    )}
                    placeholder="Add on-call policy"
                    onChange={(selectedOption) => {
                      validation.setFieldValue("on_call_policy", selectedOption.label);
                    }}
                    options={availablePoliciesOptions}
                    className="select2-selection col-form-label"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>
                <div className="mb-3">
                  <Label htmlFor="name">Select Team</Label>
                  <Select
                    id="bluejay_team"
                    name="bluejay_team"
                    onBlur={validation.handleBlur}
                    value={availalbeTeamsOptions.find((option) => option.label === validation.values.bluejay_team)}
                    placeholder="Add Temperstack Team"
                    onChange={(selectedOption) => {
                      validation.setFieldValue("bluejay_team", selectedOption.label);
                    }}
                    options={availalbeTeamsOptions}
                    className="select2-selection col-form-label"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>
                <div className="mb-3 d-flex align-items-center">
                  <Form>
                    <Label htmlFor="name" className="me-3">Receive Alert Notification At:</Label>
                    <ul style={{ justifyContent: 'center', alignItems: 'center' }}>
                      {communicationChannelsById.map((channel) => {
                        if ((domain !== 'msteamtestaccount.temperstack.com' && domain !== '10xengg.myapp.com' && !domain.endsWith('temperstack.dev')) && channel.name === NOTIFICATION_CHANNEL.MS_TEAMS) {
                          return null;
                        }
                        return (
                          <FormGroup check inline key={channel.id} className="me-3">
                            <Input
                              type="checkbox"
                              id={channel.id}
                              name={channel.name}
                              checked={selectedIds.includes(channel.id)}
                              onChange={(event) => handleCheckboxChange(channel.id, event.target.checked)}
                              style={{ display: 'none' }}
                            />
                            <Label check for={channel.id} style={{ display: 'flex', alignItems: 'center' }}>
                              <i
                                className={
                                  selectedIds.includes(channel.id)
                                    ? 'bx bx-check-square bx-sm'
                                    : 'bx bx-square bx-sm'
                                }
                                onClick={() => handleCheckboxChange(channel.id, !selectedIds.includes(channel.id))}
                                style={{ marginRight: '0.5rem' }}
                              ></i>
                              {channel.name}
                            </Label>
                          </FormGroup>)
                      }
                      )}
                    </ul>
                  </Form>
                </div>
              </Col>
            </Row>
            <Row>
              <div className="text-end">
                <button
                  type="submit"
                  className="btn btn-success save-user"
                >
                  Update
                </button>
              </div>
            </Row>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  )
}
OnEditModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  serviceId: PropTypes.any
}

export default OnEditModal